const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 110",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 9.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5051",
    d: "M121.094 137h-.279l-.522 2.608h1.322z",
    transform: "translate(-105.193 -121.173)",
    style: {
      fill: "#faa100"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5052",
    d: "M381.374 257a6.814 6.814 0 0 0 1.071 1.89 6.883 6.883 0 0 0 1.114-1.89z",
    transform: "translate(-354.924 -235.956)",
    style: {
      fill: "#faa100"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5053",
    d: "M252.416 91h-8.1l1.689 13.55a2.024 2.024 0 0 1-.483 1.484l-2.86 3.268h9.753a1.959 1.959 0 0 0 1.956-1.956V93a2 2 0 0 0-1.955-2zm0 7.217h-.174a8.274 8.274 0 0 1-1.571 2.856c.479.438.991.8 1.5 1.2a.652.652 0 0 1-.815 1.018c-.553-.437-1.073-.8-1.592-1.279-.519.477-1 .842-1.549 1.279a.652.652 0 0 1-.815-1.018c.509-.4.978-.762 1.457-1.2a8.231 8.231 0 0 1-1.528-2.856h-.174a.652.652 0 0 1 0-1.3h1.956v-.657a.652.652 0 0 1 1.3 0v.652h2a.652.652 0 0 1 0 1.3z",
    transform: "translate(-222.243 -77.173)",
    style: {
      fill: "#faa100"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5054",
    d: "M10.615 1.714A1.959 1.959 0 0 0 8.674 0H1.956A1.959 1.959 0 0 0 0 1.956V16.39a1.959 1.959 0 0 0 1.956 1.956H12.24c.19-.217.35-.354.356-.637.004-.071-1.972-15.925-1.981-15.995zM8 12.464a.652.652 0 0 1-.767-.511l-.42-2.084H4.969l-.417 2.084a.652.652 0 1 1-1.279-.253l1.3-6.521a.653.653 0 0 1 .639-.524h1.353a.653.653 0 0 1 .639.524l1.3 6.521a.652.652 0 0 1-.504.764z",
    style: {
      fill: "#faa100"
    },
    transform: "translate(9.87 9.871)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5055",
    d: "m175.261 452 .112.895a1.972 1.972 0 0 0 1.128 1.515l2.189-2.41z",
    transform: "translate(-157.772 -422.478)",
    style: {
      fill: "#faa100"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.213ff95431d2df917ecd9d9d2cc8f0cc.svg";
export { ForwardRef as ReactComponent };